import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24ExpandG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M5.512 12.218c.283 0 .512.24.512.536v4.437l4.219-4.292c.18-.183.456-.2.654-.052l.07.063a.553.553 0 0 1-.01.757l-4.19 4.262h4.209c.251 0 .46.19.504.44l.008.096c0 .295-.23.535-.512.535H5.512A.525.525 0 0 1 5 18.465v-5.711c0-.296.23-.536.512-.536M18.488 5c.251 0 .46.19.504.44l.008.095v5.711c0 .296-.23.536-.512.536a.52.52 0 0 1-.504-.44l-.008-.096V6.831l-4.303 4.51a.495.495 0 0 1-.653.064l-.071-.062a.55.55 0 0 1-.06-.683l.059-.074 4.306-4.515h-4.23a.52.52 0 0 1-.504-.44l-.008-.096c0-.262.181-.481.42-.526L13.024 5z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24ExpandG$1 = Svg24ExpandG;

export { Svg24ExpandG$1 as default };
